export function resolveRoutingChatReply(result) {
  if (!result || result.mode !== 'routing-chat') return ''
  return typeof result.message === 'string' ? result.message : ''
}
